export default "__VITE_ASSET__eb472519__"